import { Map as ImmutableMap, List, Record, type RecordOf } from 'immutable';

export interface RootUiData {
  type: string;
  id: string;
  visible: boolean;
  allowNesting: boolean;
  props: ImmutableMap<string, any>;
  createdAt?: number;
}
const RootUiDataRecord = Record<RootUiData>({
  type: 'UNKNOWN',
  id: '0',
  visible: true,
  allowNesting: true,
  props: ImmutableMap(),
  createdAt: undefined,
});

// The patched `ImmutableMap({ ... })` returns Map<string, V>, which checks cheaply against `props`. Don't add a
// `P extends MapOf<infer R>` filter here: on a plain Map it is structural, and every dialog opener pays for it.
export function mkRootUiData(values?: Partial<RootUiData>): RecordOf<RootUiData> {
  return RootUiDataRecord({
    ...values,
    createdAt: values?.createdAt ?? Date.now(),
  });
}

export interface RootUiStore {
  activeModals: List<RecordOf<RootUiData>>;
  queuedModals: List<RecordOf<RootUiData>>;
}

export const mkRootUiStore = Record<RootUiStore>({
  activeModals: List(),
  queuedModals: List(),
});

export const REDUCER_KEY = 'rootUiStore';
declare module 'app-components/utils/redux-store/rootState' {
  export default interface RootState {
    [REDUCER_KEY]: RecordOf<RootUiStore>;
  }
}
